import { lazyWithRetry } from 'common/utils';

export * from './routes';

export const NatalieListPage = lazyWithRetry(() => import('./NatalieList'));

export const NatalieWizardPage = lazyWithRetry(() => import('./NatalieWizard'));

export const NatalieChooseIntakeModePage = lazyWithRetry(() => import('./NatalieAdmin/ChooseIntakeMode'));

export const NatalieCreateIntakePage = lazyWithRetry(() => import('./NatalieAdmin/CreateIntake'));

export const NatalieCreateIntakeFormPage = lazyWithRetry(() => import('./NatalieAdmin/CreateIntakeForm'));

export const NatalieForParticipantPage = lazyWithRetry(() => import('./NatalieForParticipant'));

export const NatalieEventDetailsPage = lazyWithRetry(() => import('./NatalieEventDetails'));

export const NatalieNextHandoffPage = lazyWithRetry(() => import('./NatalieNextHandoff'));
